import { render, staticRenderFns } from "./frm_create.vue?vue&type=template&id=a4ff8b0c&"
import script from "./frm_create.vue?vue&type=script&lang=js&"
export * from "./frm_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports